import AppLoadingPhaseItem from './app-loading-phase-item';

const prefix = (name, index) => ('0' + index).slice(-2) + '_' + name;

export default class PrefixedAppLoadingPhaseItem extends AppLoadingPhaseItem {
  constructor({ name, index, phaseStartTime }) {
    super({ name, index, phaseStartTime });

    this.data.name = prefix(name, index);
  }
}
